/**
 * Extract code IDs from a selected excerpt, filtered by coding user ID if provided
 * @param {Object} selectedExcerpt - The currently selected excerpt containing codes
 * @param {String|Number|null} codingUserId - Optional user ID to filter codes by
 * @returns {Array} Array of code IDs
 */
const getSelectedCodeIds = (selectedExcerpt, codingUserId) => {
  let codeIds = [];
  
  // For new format where data is in selectedExcerpt.excerpt
  const excerptData = selectedExcerpt?.excerpt || selectedExcerpt;
  
  if (excerptData?.codings) {
    // Use codings array in new format
    codeIds = excerptData.codings
      .filter(coding => !codingUserId || String(coding.user_id) === String(codingUserId))
      .map(coding => coding.code_id);
  }
  
  return codeIds;
};

export { getSelectedCodeIds };
// Also provide a default export for backward compatibility
export default { getSelectedCodeIds };
